<hbox class="divider" />

<script lang="ts">
</script>

<style>
  .divider {
    margin: 4px 10px;
    height: 0px;
    border-top: 1px solid var(--border);
  }
</style>
